module.exports = __webpack_public_path__ + "static/media/spot18.2be10d82.webp";